module.exports = __webpack_public_path__ + "images/5cfbd50913dc953048c49ce752b71f21.png";